import { useState } from 'react';
import styles from './BrandMark.module.css';

// Small decorative RepBuddy character (logo.png) used as a recurring brand motif.
// Purely decorative - hides itself if the asset is missing so nothing ever breaks.
export default function BrandMark({ size = 48, className = '' }) {
  const [ok, setOk] = useState(true);
  if (!ok) return null;
  return (
    <img
      className={`${styles.mark} ${className}`}
      style={{ width: size, height: size }}
      src={`${process.env.PUBLIC_URL}/logo.png`}
      alt=""
      aria-hidden="true"
      onError={() => setOk(false)}
    />
  );
}
